/* eslint-disable @typescript-eslint/no-unused-vars */
import { IconX } from "@tabler/icons-react";
import NewinputField from "../../../components/NewInput";
import { Control, UseFormClearErrors } from "react-hook-form";
import { useLanguage } from "../../../context/LanguageContext";

interface AssignDriversModalProps {
  open: boolean;
  onClose: () => void;

  register?: any;
  setValue?: any;
  watch?: any;
  errors?: any;
  clearErrors?: UseFormClearErrors<any>;
  control?: Control<any>;
  zoneItem?: any;
  handleSubmit: React.MouseEventHandler<HTMLButtonElement>;
  isPending: boolean;
}

export default function CreateZoneAreaModal({
  open,
  onClose,
  register,
  errors,
  handleSubmit,
  isPending,
}: AssignDriversModalProps) {
  const { t } = useLanguage();

  if (!open) return null;

  return (
    // <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
    <div className="bg-[#F7F6F2] rounded-3xl  flex flex-col overflow-hidden">
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-3 border-b">
        <h2 className="text-lg font-medium text-[#212121]">
          {t("Create Zone & Area")}
        </h2>
        <button
          onClick={onClose}
          className="p-2 rounded-full border-[0.5px] border-[#D2D2D2]"
        >
          <IconX size={20} />
        </button>
      </div>

      {/* Drivers List */}
      <div className="flex-1  p-4 space-y-1">
        <div className="grid grid-cols-1 gap-4 ">
          <NewinputField
            labelClass="text-sm text-[#1E293B]"
            name="name"
            type="text"
            title={t("Zone / Area Setup")}
            placeholder=""
            className="rounded-full"
            register={register}
            other={{ maxLength: 3 }}
            error={errors?.name}
            validation={{
              required: t("Name is required"),
              validate: (value: string) => {
                const trimmed = value.trim();
                if (trimmed.length < 2)
                  return t("Name must be at least 2 characters long");
                if (trimmed.length > 3)
                  return t("Name must not exceed 3 characters");
                return true;
              },
            }}
          />
        </div>
      </div>

      {/* Footer */}
      <div className="flex justify-end space-x-2 p-4 border-t">
        <button
          onClick={handleSubmit}
          disabled={isPending}
          className="px-4 py-2 rounded-full bg-[#FBD037] text-black font-medium hover:bg-yellow-500 transition"
        >
          {t("Create")}
        </button>
      </div>
    </div>
    // </div>
  );
}
